<template>
  <LISAUIMessage
    v-if="isLISA3"
    v-bind="$attrs"
    :variant="variant"
    :closable="closable"
    :role="role"
  >
    <slot />
  </LISAUIMessage>
  <PrimeMessage
    v-else
    v-bind="$attrs"
    :severity="primeSeverity"
    :closable="closable"
    :sticky="sticky"
  >
    <slot />
  </PrimeMessage>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { LISAMessage as LISAUIMessage, type LISAVariant } from "@fi-solutions/lisa-ui";
import PrimeMessage from "primevue/message";
import { isLISA3 } from "@/composables/useLISA3";

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    variant?: LISAVariant;
    closable?: boolean;
    sticky?: boolean;
    role?: "alert" | "status";
  }>(),
  {
    variant: "info",
    closable: false,
    sticky: true,
    role: undefined,
  },
);

const primeSeverity = computed(() => (props.variant === "warning" ? "warn" : props.variant));
</script>
